export const compareArraysById = (array1: Array<any>, array2: Array<any>) => {
  return array1.length === array2.length && array1.every((array) => array2.find((a) => a.id === array.id));
};
